import { z } from 'zod';
import { Gender, Language, Platform, Theme } from '../enums.js';

export const updateProfileBillingSchema = z
  .object({
    company: z.string().optional(),
    company_registration: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    zip_code: z.string().optional(),
    country: z.string().optional(),
    state: z.string().optional(),
  })
  .optional();

export const updateProfileSchema = z.object({
  avatar_url: z.string().optional(),
  avatar: z.string().optional(),
  avatar_updated_at: z.string().optional(),
  gender: z.enum(Gender).optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  phone: z.string().optional(),
  billing: updateProfileBillingSchema,
  language: z.enum(Language).optional(),
  theme: z.enum(Theme).optional(),
  expo_token: z.string().optional(),
  push_enabled: z.boolean().optional(),
  platform: z.enum(Platform).optional(),
});

export type UpdateProfilePayload = z.infer<typeof updateProfileSchema>;
